// extracted by mini-css-extract-plugin
export default {"loggedInArea":"wakJvXUdPvH0HzgnJvzs","content":"_BH4q4S0K4ws9DgCUbbA","contentCardsPanel":"OGDlp7kb7JuJHDMqLMZb","currentLoanLink":"V8_AWpzFeOQgCtoGGzAO"};